<template>
  <div class="accordion">
    <h3 class="title -regular -t3">{{ title }}</h3>
    <div v-for="(item, index) in items" :key="item.title">
      <button
        class="button"
        :class="{ '-active': current == index }"
        @click="activate(index)"
        :style="{ backgroundColor: buttonColour }"
      >
        <span class="button-number">{{ index + 1 }}. </span
        ><span class="button-text">{{ item.title }}</span>
      </button>
      <transition @enter="transitionEnter" @leave="transitionLeave">
        <div class="content" v-show="current == index" ref="content">
          <v-text class="content-inner" :text="item.text" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import VText from "./Text";
import { gsap } from "gsap";
import throttle from "lodash/throttle";

export default {
  props: {
    title: String,
    items: Array,
    buttonColour: String,
  },
  data() {
    return {
      current: null,
    };
  },
  components: {
    VText,
  },
  mounted() {
    window.addEventListener("resize", this.resize);
  },
  methods: {
    activate(index) {
      this.current = this.current == index ? null : index;
    },
    transitionEnter(el, done) {
      gsap.to(el, {
        height: el.childNodes[0].getBoundingClientRect().height,
        onComplete: () => {
          this.$root.$emit("update:scrollTrigger");
          done();
        },
      });
    },
    transitionLeave(el, done) {
      gsap.to(el, {
        height: 0,
        onComplete: () => {
          this.$root.$emit("update:scrollTrigger");
          done();
        },
      });
    },
    resize: throttle(function() {
      if (null !== this.current) {
        let el = this.$refs.content[this.current];
        el.style.height =
          Math.ceil(el.childNodes[0].getBoundingClientRect().height) + "px";
      }
    }, 100),
  },
};
</script>

<style lang="scss" scoped>
@import "foundation-sites/scss/foundation.scss";
@import "@/assets/scss/_settings";
.accordion {
  margin: vw-relative(50 0 100);
}
.title {
  color: #6b2377;
  margin-bottom: 0.5em;
}
.button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: #fff;
  text-align: left;
  font: 400 24px/1 CenturyGothic;
  @include clamp-font(20px, 24px);
  border: 1px solid #060201;
  padding: vw-relative(10 20 10 30, 320);
  transition: all 0.5s;
  position: relative;
  @include breakpoint(medium) {
    padding: vw-relative(10 20 10 50);
  }
  &:after {
    content: "";
    width: 0.8em;
    height: 0.8em;
    display: block;
    background-image: url("~@/assets/images/close.svg");
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    transform: rotate(45deg);
    transition: transform 0.5s;
  }
  &.-active {
    &:after {
      transform: rotate(180deg);
    }
  }
  &-number {
    position: absolute;
    left: vw-relative(10, 320);
    @include breakpoint(medium) {
      left: vw-relative(20);
    }
  }
  &-text {
    flex: 1 0 0%;
    padding-right: 0.8em;
  }
}
.content {
  height: 0;
  overflow: hidden;
  &-inner {
    padding: vw-relative(10 20 10 50);
  }
}
</style>
